import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import { store } from "./redux/store";
import { injectStore } from "./redux/storeInjector";
import {
  initChunkErrorHandling,
  initVersionPolling,
} from "./utils/versionCheck";

injectStore(store);

initChunkErrorHandling();
initVersionPolling();

window.__pwa_deferred_prompt = null;
window.addEventListener("beforeinstallprompt", (e) => {
  e.preventDefault();
  window.__pwa_deferred_prompt = e;
  window.dispatchEvent(new Event("pwa-prompt-available"));
});

window.addEventListener("appinstalled", () => {
  localStorage.setItem("dreamclouds_pwa_installed", "true");
  window.__pwa_deferred_prompt = null;
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  // <React.StrictMode>
  <Provider store={store}>
    <App />
  </Provider>,
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// Register Service Worker
if ("serviceWorker" in navigator) {
  window.addEventListener("load", async () => {
    try {
      const registration =
        await navigator.serviceWorker.register("/service-worker.js");
    } catch (error) {
      console.error("SW registration failed:", error);
    }
  });
}
